/*!
 * Copyright (C) SPREAD WORKS Inc. All Rights Reserved.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
'use strict';

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'bootstrap';

$(function(){
	//
    // ナビゲーションのエフェクト
    //
    let $nav = $('#sw-header');
	let navPos = $nav.offset().top;
	let navHeight = $nav.outerHeight();
    var isScroll = false;
    $(window).on('load scroll', function () {
        if (!isScroll && $(this).scrollTop() > navHeight) {
            $nav.addClass("sw-effect");
            isScroll = true;
        } else if (isScroll && $(this).scrollTop() <= navHeight) {
            $nav.removeClass("sw-effect");
            isScroll = false;
        }
    });



    const sleep = waitTime => new Promise( resolve => setTimeout(resolve, waitTime) );

    const typetext = async function(element,text = null,index = 0) {
        if (text == null) text = element.innerText;
        let speed = element.getAttribute('data-speed') ? element.getAttribute('data-speed') : 100;
        if (index == 0) {
            element.innerText = '';
            element.style.opacity = 0;
            let delay = 0;
            if ((delay = element.getAttribute('data-delay')) && delay != 0) {
                await sleep(delay);
                element.style.opacity = 1;
            }
        } 
        if (index <= text.length) {
            element.innerText = text.substring(0, index);
            setTimeout(function() {
                typetext(element,text,index+1);
            }, speed);
        }
    }
    let typewriterElements = Array.from(document.getElementsByClassName('sw-anime-typewriter'));
    typewriterElements.forEach(function(element){
        typetext(element);
    });

    //
    // ページを上へ
    //
    var scrollSpeed = 600;
    $(window).scroll(function(){
        if ($(this).scrollTop() > $("#sw-header").outerHeight()) {
            $(".sw-pageup").css('display','flex');
        // } else {
        //     $(".sw-pageup").css('display','none');
        }
    });
    // $('.sw-smooth-scroll').click(function () {
    //     var href = $(this).attr("href");
    //     var target = $(href == "#" || href == "" ? 'html' : href);
    //     // スクロール後にナビ部分をdisplay:fixedにするため、それ以降の要素の位置を再計算する必要がある。
    //     // 一旦、少し下げた後に、ターゲットの高さを計測し、再度スクロールアニメーションさせる。
    //     $("html,body").animate({
    //         scrollTop: 0
    //     }, scrollSpeed, function () {
    //         // var position = 0;
    //         // position -= $("#sw-header").outerHeight();
    //         // $("html,body").animate({
    //         //     scrollTop: position
    //         // }, scrollSpeed, "swing");
    //     });
    //     return false;
    // });
    // $(window).scroll(function () {
    //   var check = window.pageYOffset;
    //   var docHeight = $(document).height();
    //   var dispHeight = $(window).height();
    //   if(check > docHeight-dispHeight-60){
    //     $('.sw-smooth-scroll').slideUp(200);
    //   }else{
    //     $('.sw-smooth-scroll').slideDown(200);
    //   }
    // });
});

//
// 要素が表示されたらエフェクト
//
var scrollElem = undefined;
let scrollAnimation = function() {
    if (scrollElem == undefined) scrollElem = document.querySelectorAll('.sw-anime');
    for (let i = 0; i < scrollElem.length; i++) {
        let trigger = 50;
        if (window.innerHeight > scrollElem[i].getBoundingClientRect().top + trigger) {
            scrollElem[i].classList.add('sw-effect');
        } else {
            scrollElem[i].classList.remove('sw-effect');
        }
    }
}
window.addEventListener('load', scrollAnimation);
window.addEventListener('scroll', scrollAnimation);
